import branding_phone from "./../assets/images/image-branding.jpg";
import branding_phone1 from "./../assets/images/image-branding-1.jpeg";
import branding_phone2 from "./../assets/images/image-branding-2.jpeg"
import branding_phone3 from "./../assets/images/image-branding-3.jpeg";

export const projects = [
  {
    project_link: "projects/brandidentity",
    project_image: branding_phone,
    project_title: "Brand Identity",
    project_category: "Branding",
    short_description:
      "Revamping the brand identity for a local coffee shop.",
    client: "Coffee & Co.",
    delivery_date: "4th January 2024",
    project_overview:
      "Coffee & Co. is a cozy coffee shop located in the heart of downtown. They have been serving their community for over a decade and have developed a loyal customer base. However, their branding feels outdated and does not reflect the unique atmosphere of their shop. This project aims to revamp their brand identity to better align with their values and attract a younger audience.",
    objectives: [
      "Modernize the logo while retaining elements of familiarity.",
      "Create a cohesive visual identity system including color palette and typography.",
      "Develop branding collateral such as menus, signage, and packaging."
    ],
    scope_of_work: [
      "Logo redesign",
      "Color palette selection",
      "Typography selection",
      "Menu design",
      "Signage design",
      "Packaging design"
    ],
    project_images: [
      branding_phone,
      branding_phone1,
      branding_phone2,
      branding_phone3
    ]
  },
];